import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
$(function () {
  gsap.registerPlugin(ScrollTrigger);
  testimonialAnimation();
  fadeInOutSidebar();
});

function testimonialAnimation() {
  gsap.utils.toArray(".box-wrapper").forEach((panel) => {
    ScrollTrigger.matchMedia({
      "(max-width: 767px)": function () {
        overlayImageOnTextAnimation(
          panel,
          "-10%",
          "+=100%",
          panel.querySelector(".js-animate-testimonial"),
          panel.querySelector(".js-animate-image")
        );
      },
      "(min-width: 768px)": function () {
        overlayImageOnTextAnimation(
          panel,
          "-10%",
          "+=100%",
          panel.querySelector(".js-animate-testimonial"),
          panel.querySelector(".js-animate-image")
        );
      },
    });
  });
}

function fadeInOutSidebar() {
  // Fade in/out the sidebar
  gsap.utils.toArray(".fade-out-scroll-js").forEach((panel) => {
    const sidebar = panel.querySelector(".sidebar-sticky-js");

    ScrollTrigger.saveStyles(".mobile, .desktop");

    ScrollTrigger.matchMedia({
      // desktop
      "(min-width: 768px)": function () {
        let checkpoint =
          panel.querySelector(".header-fade-out-js").clientHeight -
          sidebar.querySelector(".sidebar-body").clientHeight / 1.5 -
          280 +
          "px";

        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: panel,
            start: "top",
            end: checkpoint,
            scrub: true,
          },
          defaults: {
            ease: "none",
          },
        });

        tl.fromTo(
          sidebar,
          {
            opacity: 1,
          },
          {
            opacity: 0,
          }
        );
      },

      // mobile
      "(max-width: 767px)": function () {
        let checkpoint =
          panel.querySelector(".header-fade-out-js").clientHeight +
          sidebar.querySelector(".sidebar-body").clientHeight +
          "px";

        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: panel,
            start: "-40px",
            end: checkpoint,
            scrub: true,
            pin: true,
            pinSpacing: false,
            anticipatePin: 1,
          },
          defaults: {
            ease: "none",
          },
        });

        tl.to(sidebar, {
          top: "-100%",
          duration: 1,
        });
        tl.to(
          panel.querySelector(".header-fade-out-js"),
          {
            top: "-100%",
            duration: 1,
          },
          "-=.85"
        );
      },
      // all
      all: function () {
        // ScrollTriggers created here aren't associated with a particular media query,
        // so they persist.
      },
    });
  });
}

function overlayImageOnTextAnimation(
  trigger,
  start,
  end = "+=100%",
  textEl,
  imageEl
) {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: trigger,
      start: start,
      end: end,
      scrub: true,
      pin: true,
    },
    defaults: {
      ease: "none",
    },
  });

  tl.add("start", 0);
  tl.add("start1", 1);
  tl.add("start2", 2);
  tl.fromTo(
    textEl,
    {
      opacity: 1,
    },
    {
      opacity: 0.8,
    }
  );
  tl.to(
    textEl,
    {
      opacity: 0,
    },
    "start1"
  );
  tl.fromTo(
    imageEl,
    {
      yPercent: 115,
      xPercent: 0,
      height: "100%",
      left: 0,
    },
    {
      yPercent: 0,
    },
    "start1"
  );
  tl.fromTo(
    imageEl,
    {
      opacity: 1,
    },
    {
      opacity: 1.5,
    },
    "start2"
  );

  $("#collapseOurStory").on("hidden.bs.collapse", function () {
    tl.scrollTrigger.refresh();
  });
  $("#collapseOurStory").on("shown.bs.collapse", function () {
    tl.scrollTrigger.refresh();
  });
}
